import type { TrackAnalyticsBody } from '@shared/api'
import { useMutation } from 'react-query'
import { ApiService } from 'src/services/api.service'

export function useTrack() {
  return useMutation(({ event, properties }: TrackAnalyticsBody) => ApiService.Analytics.track(event, properties))
}
